import DownloadButton from "../DownloadButton";
import {
  capitalizeFirstLetterOfEachWord,
  formatFileUrlValue,
} from "../../utils/Formatter";
import ProfilePlaceholder from "../../assets/svgIcons/ProfilePlaceholder.svg";
import "../../styles/components/transactionPrintLayouts/POInvoiceLayout.css";

export const SalesEnquiryLayout = ({
  headDetails,
  companyData,
  itemDetails,
  rowData,
  invoiceTableData,
  selectedReportName,
}) => {
  const path = window.location.pathname.split("/").filter(Boolean);
  const transactionName = selectedReportName || path[1];

  const organizationData = JSON.parse(localStorage.getItem("organisation"));

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const notes = [
    "All details mentioned are subject to verification.",
    "This document is for enquiry purposes only and does not constitute an offer.",
  ];

  const formatCompanyAddress = (companyData) => {
    if (!companyData) return "N/A";

    const parts = [
      companyData.address?.trim(),
      companyData.city?.trim(),
    ].filter(Boolean);

    const pin = companyData.pincode ? `- ${companyData.pincode}` : "";

    return parts.length > 0 || pin
      ? `${parts.join(", ")} ${pin}`.trim()
      : "N/A";
  };

  const visibleFields = [...rowData]
    .filter((field) => !field.is_internal_field)
    .reverse();

  return (
    <div className="invoice-container sales-enquiry-layout quotation-page-container">
      <div className="invoice-box">
        <div className="invoice-left">
          <div className="invoice-logo-container">
            <img
              src={organizationData.logo_url || ProfilePlaceholder}
              alt="Logo"
              className="invoice-logo-content"
            />
          </div>
          <div>
            <h3 className="invoice-company-name">
              {organizationData.name || "N/A"}
            </h3>
            <p className="invoice-company-address">
              {formatCompanyAddress(organizationData) || "N/A"}
              <br />
              GSTIN: {organizationData.gst_no || "N/A"}
              <br />
              State: {organizationData.state || "N/A"}
            </p>
          </div>
        </div>

        <div className="invoice-center">
          <h2 className="invoice-title">
            {capitalizeFirstLetterOfEachWord(transactionName || "")}
          </h2>
        </div>

        <div className="invoice-right">
          {[
            { label: "Sales Enquiry No", value: headDetails.tran_no },
            {
              label: "Sales Enquiry Date",
              value: formatDate(headDetails.date),
            },
            { label: "Mail Date", value: formatDate(headDetails.mail_date) },
            { label: "Priority", value: headDetails.estimated },
          ].map((item, index) => (
            <div key={index} className="purchase-detail">
              <p className="detail-label">
                <strong>{item.label}:</strong>
              </p>
              <div className="detail-value">{item.value}</div>
            </div>
          ))}
        </div>
      </div>

      <div
        className="workorder-header-row workorder-meta-row"
        style={{
          borderLeft: "1px solid #9ca3af",
          borderRight: "1px solid #9ca3af",
          gridTemplateColumns: "0.95fr 0.55fr 1.1fr 1.15fr 2.25fr",
        }}
      >
        <div className="workorder-meta-cell">
          <span className="workorder-meta-label">Lead Time:</span>
          <span className="workorder-meta-value workorder-date-value">
            {formatDate(headDetails.lead_time)}
          </span>
        </div>
        <div className="workorder-meta-cell">
          <span className="workorder-meta-label">Type:</span>
          <span className="workorder-meta-value">
            {headDetails.type || headDetails.tran_type || headDetails.transaction_type || ""}
          </span>
        </div>
        <div className="workorder-meta-cell">
          <span className="workorder-meta-label">Order Type:</span>
          <span className="workorder-meta-value" style={{ whiteSpace: "nowrap" }}>
            {headDetails.enquiry_type}
          </span>
        </div>
        <div className="workorder-meta-cell">
          <span className="workorder-meta-label">Assigned Engineer:</span>
          <span className="workorder-meta-value">
            {headDetails.assignee_name}
          </span>
        </div>
        <div className="workorder-meta-cell">
          <span className="workorder-meta-label">Enquiry Description:</span>
          <span className="workorder-meta-value">
            {headDetails.enquiry_desctiption}
          </span>
        </div>
      </div>

      <div className="invoice-supplier-details-container">
        <div className="invoice-supplier-section">
          <h4 className="invoice-section-title">Name of Customer:</h4>
          <p className="invoice-section-text">
            <span style={{ fontSize: "14px", fontWeight: "bolder" }}>
              {companyData.company_name || "N/A"}
            </span>
            <br />
            Address: {companyData.company_address || "N/A"}
            <br />
            State: {companyData.company_state || "N/A"}
          </p>
        </div>

        <div className="invoice-delivery-section">
          <h4 className="invoice-section-title">Delivery at:</h4>
          <p className="invoice-section-text">
            <span style={{ fontSize: "14px", fontWeight: "bolder" }}>
              {companyData.company_name || "N/A"}
            </span>
            <br />
            Address: {companyData.company_address || "Address not specified"}
            <br />
            GSTIN: {companyData.company_gst_no || "N/A"}
            <br />
            State: {companyData.company_state || "N/A"}
          </p>
        </div>
      </div>

      <div className="invoice-overflow-x-scroll">
        <table className="invoice-table">
          <thead className="invoice-thead">
            <tr>
              <th className="invoice-th" style={{ borderLeftWidth: "0px" }}>
                No.
              </th>
              {visibleFields.map((field, index) => (
                <th
                  key={index}
                  className="invoice-th"
                  style={
                    index === visibleFields.length - 1
                      ? { borderRightWidth: "0px" }
                      : {}
                  }
                >
                  {field.title || field.field_name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {itemDetails.map((item, index) => (
              <tr key={index}>
                <td className="invoice-td" style={{ borderLeftWidth: "0px" }}>
                  {index + 1}
                </td>
                {[...rowData]
                  .filter((field) => !field.is_internal_field)
                  .reverse()
                  .map((field, idx, arr) => (
                    <td
                      key={idx}
                      className="invoice-td"
                      style={
                        idx === arr.length - 1
                          ? { borderRightWidth: "0px" }
                          : {}
                      }
                    >
                      {formatFileUrlValue(item[field.field_name]) || "-"}
                    </td>
                  ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="invoice-grid-container no-top-border">
        <div className="invoice-left-pane note-pane">
          <p
            className="invoice-note-heading"
            style={{
              paddingLeft: "16px",
              paddingRight: "16px",
              paddingTop: "16px",
            }}
          >
            <strong>Note: </strong>
          </p>
          <ul className="invoice-note-list">
            {notes.map((note, index) => (
              <li key={index} className="invoice-note-item">
                {note}
              </li>
            ))}
          </ul>
        </div>

        <div className="invoice-right-pane">
          <div className="invoice-footer-signature">
            <p style={{ margin: "0px", fontSize: "13px" }}>
              <strong>For, {organizationData.name}</strong>
            </p>
          </div>
        </div>
      </div>
      <div
        className="workorder-header-row workorder-meta-row"
        style={{
          borderLeft: "1px solid #9ca3af",
          borderRight: "1px solid #9ca3af",
          borderTop: "none",
          gridTemplateColumns: "1fr",
        }}
      >
        <div className="workorder-meta-cell">
          <span className="workorder-meta-label">Prepared By:</span>
          <span className="workorder-meta-value">
            {headDetails.prepared_by || ""}
          </span>
        </div>
      </div>
      <div className="invoice-footer-meta-block">
        <div
          className="workorder-header-row workorder-meta-row"
          style={{
            borderLeft: "1px solid #9ca3af",
            borderRight: "1px solid #9ca3af",
            borderTop: "none",
            gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
          }}
        >
          <div className="workorder-meta-cell">
            <span className="workorder-meta-label">Ref No:</span>
            <span className="workorder-meta-value">FP/SE/01</span>
          </div>
          <div className="workorder-meta-cell">
            <span className="workorder-meta-label">Revision No:</span>
            <span className="workorder-meta-value">01</span>
          </div>
          <div className="workorder-meta-cell">
            <span className="workorder-meta-label">Revision Date:</span>
            <span className="workorder-meta-value">06/06/2026</span>
          </div>
        </div>
      </div>
      <p className="invoice-system-generated-note">
        This is a system-generated document and does not require a signature.
      </p>
      <div className="invoice-buttons" style={{ paddingTop: "40px" }}>
        <DownloadButton
          tableData={invoiceTableData}
          fileName="quotation"
          downloadFormats={["excel", "pdf", "full-page-pdf"]}
          fullPageDownload={true}
          fullPageSelector=".quotation-page-container"
        />
      </div>
    </div>
  );
};
